module.exports = __webpack_public_path__ + "static/media/atmo.70d57cbc.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/img/atmo.PNG
// module id = 97
// module chunks = 0